<script lang="ts">
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';
	import SbRichtext from '../components/sbRichtext.svelte';
	import { editable } from '../editable';

	interface Props {
		content: ISbStoryData<{
			label: string;
			content: ISbRichtext;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<article use:editable={content} class="flex flex-col text-brown-1 lg:flex-row">
	{#if content.label?.length > 0}
		<h1 class="text-[20px]/[140%] max-lg:tracking-[-.2px] lg:basis-1/2 lg:text-[16px]/[150%]">
			{content.label}
		</h1>
	{/if}
	<div class="text-balance text-[14px]/[150%] max-lg:mt-2 lg:basis-1/2 lg:text-[16px]/[150%]">
		<SbRichtext text={content.content} />
	</div>
</article>
